module.exports = __webpack_public_path__ + "img/scan-banner.7ecab7c0.png";